import React, { useState } from 'react';
import { FaSearch, FaUser, FaGlobe, FaDesktop, FaClock, FaFile, FaMapMarkerAlt } from 'react-icons/fa';
const OnlineCustomers = () => {
  const [activeTab, setActiveTab] = useState('all');
  const [searchTerm, setSearchTerm] = useState('');
  const customers = [
    {
      id: 1,
      customerInfo: 'Guest',
      ipAddress: '104.23.251.210',
      location: 'United States',
      lastActivity: '11/04/2025 1:29:41 AM',
      lastVisitedPage: '"Store last visited page" setting is disabled'
    },
    {
      id: 2,
      customerInfo: 'Guest',
      ipAddress: '104.23.251.52',
      location: 'United States',
      lastActivity: '11/04/2025 1:29:34 AM',
      lastVisitedPage: '"Store last visited page" setting is disabled'
    },
    {
      id: 3,
      customerInfo: 'Guest',
      ipAddress: '172.68.129.156',
      location: 'Israel',
      lastActivity: '11/04/2025 1:28:41 AM',
      lastVisitedPage: '"Store last visited page" setting is disabled'
    },
    {
      id: 4,
      customerInfo: 'Guest',
      ipAddress: '104.23.251.71',
      location: 'United States',
      lastActivity: '11/04/2025 1:28:38 AM',
      lastVisitedPage: '"Store last visited page" setting is disabled'
    },
    {
      id: 5,
      customerInfo: 'Guest',
      ipAddress: '172.68.228.163',
      location: 'United States',
      lastActivity: '11/04/2025 1:28:03 AM',
      lastVisitedPage: '"Store last visited page" setting is disabled'
    },
    {
      id: 6,
      customerInfo: 'Guest',
      ipAddress: '172.68.228.158',
      location: 'United States',
      lastActivity: '11/04/2025 1:27:56 AM',
      lastVisitedPage: '"Store last visited page" setting is disabled'
    },
    {
      id: 7,
      customerInfo: 'Guest',
      ipAddress: '104.23.251.52',
      location: 'United States',
      lastActivity: '11/04/2025 1:27:49 AM',
      lastVisitedPage: '"Store last visited page" setting is disabled'
    },
    {
      id: 8,
      customerInfo: 'admin@youStore.com',
      ipAddress: '104.23.251.107',
      location: 'United States',
      lastActivity: '11/04/2025 1:27:42 AM',
      lastVisitedPage: '"Store last visited page" setting is disabled'
    },
    {
      id: 9,
      customerInfo: 'Guest',
      ipAddress: '172.68.228.149',
      location: 'United States',
      lastActivity: '11/04/2025 1:26:55 AM',
      lastVisitedPage: '"Store last visited page" setting is disabled'
    },
    {
      id: 10,
      customerInfo: 'Guest',
      ipAddress: '104.23.251.112',
      location: 'United States',
      lastActivity: '11/04/2025 1:26:52 AM',
      lastVisitedPage: '"Store last visited page" setting is disabled'
    },
    {
      id: 11,
      customerInfo: 'Guest',
      ipAddress: '104.23.251.34',
      location: 'United States',
      lastActivity: '11/04/2025 1:25:46 AM',
      lastVisitedPage: '"Store last visited page" setting is disabled'
    },
    {
      id: 12,
      customerInfo: 'Guest',
      ipAddress: '172.64.211.150',
      location: 'United States',
      lastActivity: '11/04/2025 1:25:32 AM',
      lastVisitedPage: '"Store last visited page" setting is disabled'
    },
    {
      id: 13,
      customerInfo: 'Guest',
      ipAddress: '172.68.228.158',
      location: 'United States',
      lastActivity: '11/04/2025 1:23:26 AM',
      lastVisitedPage: '"Store last visited page" setting is disabled'
    }
  ];

  const filteredCustomers = customers.filter(customer =>
    customer.customerInfo.toLowerCase().includes(searchTerm.toLowerCase()) ||
    customer.ipAddress.toLowerCase().includes(searchTerm.toLowerCase()) ||
    customer.location.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const getCustomerType = (customerInfo) => {
    return customerInfo === 'Guest' ? 'guest' : 'registered';
  };

  return (
    <div className="min-h-screen bg-gray-50 p-4 lg:p-8">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="mb-8">
          <h1 className="text-2xl lg:text-3xl font-bold text-gray-900 mb-2">
            Online customers
          </h1>
          <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
            <p className="text-gray-600 text-sm lg:text-base">
              Learn more about online customers
            </p>
            
            {/* Search Bar */}
            <div className="relative w-full lg:w-80">
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <FaSearch className="h-4 w-4 text-gray-400" />
              </div>
              <input
                type="text"
                placeholder="Search customers, IP, location..."
                className="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md leading-5 bg-white placeholder-gray-500 focus:outline-none focus:placeholder-gray-400 focus:ring-1 focus:ring-blue-500 focus:border-blue-500 text-sm"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>
          </div>
        </div>

        {/* Stats Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
          <div className="bg-white rounded-lg p-4 shadow-sm border">
            <div className="flex items-center">
              <div className="p-2 bg-blue-100 rounded-lg">
                <FaUser className="w-5 h-5 text-blue-600" />
              </div>
              <div className="ml-4">
                <p className="text-sm font-medium text-gray-600">Total Online</p>
                <p className="text-2xl font-bold text-gray-900">{filteredCustomers.length}</p>
              </div>
            </div>
          </div>
          <div className="bg-white rounded-lg p-4 shadow-sm border">
            <div className="flex items-center">
              <div className="p-2 bg-green-100 rounded-lg">
                <FaUser className="w-5 h-5 text-green-600" />
              </div>
              <div className="ml-4">
                <p className="text-sm font-medium text-gray-600">Registered</p>
                <p className="text-2xl font-bold text-gray-900">
                  {filteredCustomers.filter(c => c.customerInfo !== 'Guest').length}
                </p>
              </div>
            </div>
          </div>
          <div className="bg-white rounded-lg p-4 shadow-sm border">
            <div className="flex items-center">
              <div className="p-2 bg-orange-100 rounded-lg">
                <FaUser className="w-5 h-5 text-orange-600" />
              </div>
              <div className="ml-4">
                <p className="text-sm font-medium text-gray-600">Guests</p>
                <p className="text-2xl font-bold text-gray-900">
                  {filteredCustomers.filter(c => c.customerInfo === 'Guest').length}
                </p>
              </div>
            </div>
          </div>
          <div className="bg-white rounded-lg p-4 shadow-sm border">
            <div className="flex items-center">
              <div className="p-2 bg-purple-100 rounded-lg">
                <FaGlobe className="w-5 h-5 text-purple-600" />
              </div>
              <div className="ml-4">
                <p className="text-sm font-medium text-gray-600">Countries</p>
                <p className="text-2xl font-bold text-gray-900">
                  {new Set(filteredCustomers.map(c => c.location)).size}
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Mobile Tabs */}
        <div className="lg:hidden mb-6">
          <div className="flex space-x-1 bg-white rounded-lg p-1 shadow-sm border">
            {['all', 'registered', 'guests'].map((tab) => (
              <button
                key={tab}
                className={`flex-1 py-2 px-3 text-sm font-medium rounded-md transition-colors ${
                  activeTab === tab
                    ? 'bg-blue-100 text-blue-700'
                    : 'text-gray-600 hover:text-gray-900'
                }`}
                onClick={() => setActiveTab(tab)}
              >
                {tab.charAt(0).toUpperCase() + tab.slice(1)}
              </button>
            ))}
          </div>
        </div>

        {/* Desktop Filter Bar */}
        <div className="hidden lg:flex items-center justify-between mb-6 bg-white p-4 rounded-lg shadow-sm border">
          <div className="flex items-center space-x-4">
            <span className="text-sm font-medium text-gray-700">Filter:</span>
            {['all', 'registered', 'guests'].map((tab) => (
              <button
                key={tab}
                className={`px-4 py-2 text-sm font-medium rounded-md transition-colors ${
                  activeTab === tab
                    ? 'bg-blue-100 text-blue-700'
                    : 'text-gray-600 hover:text-gray-900'
                }`}
                onClick={() => setActiveTab(tab)}
              >
                {tab.charAt(0).toUpperCase() + tab.slice(1)}
              </button>
            ))}
          </div>
          <div className="flex items-center space-x-2 text-gray-500">
            <FaUser className="w-4 h-4" />
            <span className="text-sm">{filteredCustomers.length} customers online</span>
          </div>
        </div>

        {/* Customers Table */}
        <div className="bg-white rounded-lg shadow-sm border overflow-hidden">
          {/* Mobile Cards */}
          <div className="lg:hidden">
            {filteredCustomers.map((customer) => (
              <div key={customer.id} className="border-b border-gray-200 p-4">
                <div className="flex justify-between items-start mb-3">
                  <div className="flex items-center">
                    <div className={`p-2 rounded-full ${
                      getCustomerType(customer.customerInfo) === 'guest' 
                        ? 'bg-orange-100' 
                        : 'bg-green-100'
                    }`}>
                      <FaUser className={`w-4 h-4 ${
                        getCustomerType(customer.customerInfo) === 'guest' 
                          ? 'text-orange-600' 
                          : 'text-green-600'
                      }`} />
                    </div>
                    <div className="ml-3">
                      <h3 className="font-semibold text-gray-900 text-sm">
                        {customer.customerInfo}
                      </h3>
                      <p className="text-xs text-gray-500 mt-1">{customer.ipAddress}</p>
                    </div>
                  </div>
                  <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
                    Online
                  </span>
                </div>
                
                <div className="space-y-2">
                  <div className="flex items-center text-sm">
                    <FaMapMarkerAlt className="w-3 h-3 text-gray-400 mr-2" />
                    <span className="text-gray-700">{customer.location}</span>
                  </div>
                  <div className="flex items-center text-sm">
                    <FaClock className="w-3 h-3 text-gray-400 mr-2" />
                    <span className="text-gray-700">{customer.lastActivity}</span>
                  </div>
                  <div className="flex items-start text-sm">
                    <FaFile className="w-3 h-3 text-gray-400 mr-2 mt-0.5" />
                    <span className="text-gray-700 text-xs">{customer.lastVisitedPage}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Desktop Table */}
          <div className="hidden lg:block overflow-x-auto">
            <table className="min-w-full divide-y divide-gray-200">
              <thead className="bg-gray-50">
                <tr>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Customer info
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    IP Address
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Location
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Last activity
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Last visited page
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {filteredCustomers.map((customer) => (
                  <tr key={customer.id} className="hover:bg-gray-50">
                    <td className="px-6 py-4 whitespace-nowrap">
                      <div className="flex items-center">
                        <div className={`p-2 rounded-full ${
                          getCustomerType(customer.customerInfo) === 'guest' 
                            ? 'bg-orange-100' 
                            : 'bg-green-100'
                        }`}>
                          <FaUser className={`w-4 h-4 ${
                            getCustomerType(customer.customerInfo) === 'guest' 
                              ? 'text-orange-600' 
                              : 'text-green-600'
                          }`} />
                        </div>
                        <div className="ml-3">
                          <div className="text-sm font-medium text-gray-900">
                            {customer.customerInfo}
                          </div>
                          <div className="text-xs text-gray-500">
                            {getCustomerType(customer.customerInfo) === 'guest' ? 'Guest' : 'Registered'}
                          </div>
                        </div>
                      </div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <div className="flex items-center text-sm text-gray-900">
                        <FaDesktop className="w-4 h-4 text-gray-400 mr-2" />
                        {customer.ipAddress}
                      </div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <div className="flex items-center text-sm text-gray-900">
                        <FaMapMarkerAlt className="w-4 h-4 text-gray-400 mr-2" />
                        {customer.location}
                      </div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                      <div className="flex items-center">
                        <FaClock className="w-4 h-4 text-gray-400 mr-2" />
                        {customer.lastActivity}
                      </div>
                    </td>
                    <td className="px-6 py-4 text-sm text-gray-500 max-w-xs">
                      <div className="flex items-start">
                        <FaFile className="w-4 h-4 text-gray-400 mr-2 mt-0.5 flex-shrink-0" />
                        <span className="text-xs">{customer.lastVisitedPage}</span>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* 2XL Screens Enhanced Layout */}
          <div className="hidden 2xl:block">
            {/* Additional enhancements for very large screens can go here */}
          </div>
        </div>

        {/* Empty State */}
        {filteredCustomers.length === 0 && (
          <div className="text-center py-12">
            <div className="text-gray-400 text-6xl mb-4">👥</div>
            <h3 className="text-lg font-medium text-gray-900 mb-2">No customers online</h3>
            <p className="text-gray-500 max-w-md mx-auto">
              No online customers match your current search criteria. Try adjusting your search terms.
            </p>
          </div>
        )}

        {/* Footer Info */}
        <div className="mt-6 text-center">
          <p className="text-xs text-gray-500">
            Last updated: {new Date().toLocaleString()}
          </p>
        </div>
      </div>
    </div>
  );
};

export default OnlineCustomers;